import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17b32ec1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-pptx-dialog" }
const _hoisted_2 = { class: "configs" }
const _hoisted_3 = {
  class: "row",
  style: {"justify-content":"flex-start"}
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "radio-list" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = ["data-range"]
const _hoisted_8 = {
  class: "row",
  style: {"justify-content":"space-between","padding":"1em 0"}
}
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "tip" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1735349497798",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4209",
  width: "32",
  height: "32"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M512 85.333333C276.48 85.333333 85.333333 276.48 85.333333 512S276.48 938.666667 512 938.666667 938.666667 747.52 938.666667 512 747.52 85.333333 512 85.333333zM483.555556 307.2c0-15.928889 12.515556-28.444444 28.444444-28.444444s28.444444 12.515556 28.444444 28.444444v238.933333c0 15.928889-12.515556 28.444444-28.444444 28.444445s-28.444444-12.515556-28.444444-28.444445V307.2zM512 722.488889c-21.617778 0-39.822222-18.204444-39.822222-39.822222s18.204444-39.822222 39.822222-39.822223 39.822222 18.204444 39.822222 39.822223-18.204444 39.822222-39.822222 39.822222z",
    "p-id": "4210",
    fill: "#a8aab0"
  })
], -1))
const _hoisted_13 = { class: "btns" }

import { computed, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import useExport from '@/hooks/useExport'
import { useI18n } from 'vue-i18n'
import { saveClickData } from "@/api/combo";
import Cookies from 'js-cookie'
import { sendClickData } from "@/utils/common";

import { event } from 'vue-gtag';

import FullscreenSpin from '@/components/FullscreenSpin.vue'
import {
  Button,
  Slider,
  Switch,
  Radio,
} from 'ant-design-vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ExportPPTX',
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const { t, locale } = useI18n()
const { Group: RadioGroup, Button: RadioButton } = Radio



const { slides, currentSlide } = storeToRefs(useSlidesStore())

const { daochuppt, exporting } = useExport()

const rangeType = ref<'all' | 'current' | 'custom'>('all')
const range = ref<[number, number]>([1, slides.value.length])
const masterOverwrite = ref(true)

const selectedSlides = computed(() => {
  if (rangeType.value === 'all') return slides.value
  if (rangeType.value === 'current') return [currentSlide.value]
  return slides.value.filter((item, index) => {
    const [min, max] = range.value
    return index >= min - 1 && index <= max - 1
  })
})

const beforeExportPPTX = (selectedSlides: any, masterOverwrite: any) => {
  setTimeout(() => {
    sendClickData(16, 16, '', '')
  }, 100)
  event('ppt_download')
  daochuppt(selectedSlides, masterOverwrite)
  // sendClickData type = 16
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`editor.exportDialog.exportScope`)) + "：", 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': rangeType.value === 'all' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (rangeType.value = 'all'))
          }, _toDisplayString(_ctx.$t(`editor.exportDialog.all`)), 3),
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': rangeType.value === 'current' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (rangeType.value = 'current'))
          }, _toDisplayString(_ctx.$t(`editor.exportDialog.thisPage`)), 3),
          _createElementVNode("div", {
            class: _normalizeClass(['radio-item', { 'radio-active': rangeType.value === 'custom' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (rangeType.value = 'custom'))
          }, _toDisplayString(_ctx.$t(`editor.exportDialog.auto`)), 3)
        ])
      ]),
      (rangeType.value === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "title",
              style: {"text-wrap":"nowrap"},
              "data-range": `（${range.value[0]} ~ ${range.value[1]}）`
            }, _toDisplayString(_ctx.$t(`editor.exportDialog.autoScope`)) + "：", 9, _hoisted_7),
            _createVNode(_unref(Slider), {
              class: "config-item",
              range: "",
              min: 1,
              max: _unref(slides).length,
              step: 1,
              value: range.value,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((range).value = $event))
            }, null, 8, ["max", "value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`editor.exportDialog.exportPPTX.title`)) + "：", 1),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(Switch), {
            checked: masterOverwrite.value,
            "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((masterOverwrite).value = $event))
          }, null, 8, ["checked"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createTextVNode(" " + _toDisplayString(_ctx.$t(`editor.exportDialog.exportPPTX.notice`)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_unref(Button), {
        class: "btn close",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.close`)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        class: "btn export",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (beforeExportPPTX(_unref(selectedSlides), masterOverwrite.value)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`editor.exportDialog.expPptx`)), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(FullscreenSpin, {
      loading: _unref(exporting),
      tip: _unref(t)(`editor.exportDialog.exporting`)
    }, null, 8, ["loading", "tip"])
  ]))
}
}

})